import { Truss } from '@paragon/contract-library';
import { SimpleCache } from '@paragon/utilities';

export class HeightCacheClass extends SimpleCache<number> {
  get(analysisSetGuid: string, truss: Truss) {
    return this.getOrCreate(analysisSetGuid, () => {
      const memberYs = truss.members.flatMap((member) => member.geometry).map((point) => point.y);
      const lowestY = Math.min(...memberYs);
      const highestY = Math.max(...memberYs);
      const height = Math.abs(highestY - lowestY);
      return height;
    });
  }
}
